export const getEffectiveTier = (article = {}) => {
  if (article?.tierSource === 'category' || Number(article?.tierByCategory) === 1) {
    return 1;
  }

  const tierValue = article?.tier ?? article?.domainInfo?.tier;
  const tier = typeof tierValue === 'string'
    ? Number(String(tierValue).match(/[123]/)?.[0])
    : Number(tierValue);
  return [1, 2, 3].includes(tier) ? tier : null;
};

export const formatEffectiveTierLabel = (article = {}, labels = {}) => {
  const tier = getEffectiveTier(article);
  if (!tier) return '-';

  return labels[tier] || `Tier ${tier}`;
};
